<template>
  <div>
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    </div>
    <!-- Header -->
    <div class="header bg-white py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1
                class="text-black"
                style="font-size:35px"
                v-if="isLoading === true"
              >System Loading Files</h1>
              <h1 class="text-black" style="font-size:35px" v-else>Redirecting ...</h1>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import { check } from "@/api/check";
import { user } from "@/api/user";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import swal from "sweetalert2";

export default {
  components: { Loading },
  name: "loading-page",
  data() {
    return {
      isLoading: true,
      fullPage: true,
      admin1s: { id: 1, title: "Admin 1s", count: 0, checkType: "danger" },
      admin2s: { id: 2, title: "Admin 2s", count: 0, checkType: "danger" },
      admin3s: { id: 3, title: "Admin 3s", count: 0, checkType: "danger" },
      admin3gvhs: {
        id: 4,
        title: "Admin 3 Gvhs",
        count: 0,
        checkType: "danger"
      },
      admin3gvhvillages: {
        id: 5,
        title: "Admin 3 Gvh Villages",
        count: 0,
        checkType: "danger"
      },
      error: {
        status: false,
        message: ""
      },
      items: []
    };
  },
  methods: {},
  beforeMount() {
    check
      .admin1s()
      .then(
        response => {
          this.admin1s = {
            id: 1,
            title: "Admin 1s",
            count: response.data,
            checkType: response.data < 1 ? "danger" : "success"
          };
        },
        reason => {
          this.error = { status: true, message: reason };
        }
      )
      .finally(() => {
        this.items.push(this.admin1s);
      });
    check
      .admin2s()
      .then(
        response => {
          this.admin2s = {
            id: 2,
            title: "Admin 2s",
            count: response.data,
            checkType: response.data < 1 ? "danger" : "success"
          };
        },
        reason => {
          this.error = { status: true, message: reason };
        }
      )
      .finally(() => {
        this.items.push(this.admin2s);
      });
    check
      .admin3s()
      .then(
        response => {
          this.admin3s = {
            id: 3,
            title: "Admin 3s",
            count: response.data,
            checkType: response.data < 1 ? "danger" : "success"
          };
        },
        reason => {
          this.error = { status: true, message: reason };
        }
      )
      .finally(() => {
        this.items.push(this.admin3s);
      });
    check
      .admin3gvhs()
      .then(
        response => {
          this.admin3gvhs = {
            id: 4,
            title: "Admin 3 Gvhs",
            count: response.data,
            checkType: response.data < 1 ? "danger" : "success"
          };
        },
        reason => {
          this.error = { status: true, message: reason };
        }
      )
      .finally(() => {
        this.items.push(this.admin3gvhs);
      });
    check
      .admin3gvhvillages()
      .then(
        response => {
          this.admin3gvhvillages = {
            id: 5,
            title: "Admin 3 Gvh Villages",
            count: response.data,
            checkType: response.data < 1 ? "danger" : "success"
          };
        },
        reason => {
          this.error = { status: true, message: reason };
        }
      )
      .finally(() => {
        this.items.push(this.admin3gvhvillages);
      });
  },
  created() {},
  watch: {
    items: function(val) {
      if (val.length == 5) {
        if (this.error.status != true) {
          this.isLoading = false;
          if (
            this.admin1s.count != 0 &&
            this.admin2s.count != 0 &&
            this.admin3s.count != 0
          ) {
            //Success
            this.$appready.active = true;
            this.$router.push({ name: "Dashboard", params: {} });
          } else {
            //Fail
            //Clean User Account
            user.clean();
            this.$router.push({ name: "Login", params: {} });
          }
        } else {
          //Fail
          this.isLoading = false;
          //Clean User Account
          user.clean();
          this.$router.push({ name: "Login", params: {} });
        }
      }
    }
  }
};
</script>
